import { render } from "./TextAreaForm.vue?vue&type=template&id=5693b6b3&ts=true"
import script from "./TextAreaForm.vue?vue&type=script&lang=ts"
export * from "./TextAreaForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/TextAreaForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5693b6b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5693b6b3', __exports__)) {
    api.reload('5693b6b3', __exports__)
  }
  
  module.hot.accept("./TextAreaForm.vue?vue&type=template&id=5693b6b3&ts=true", () => {
    api.rerender('5693b6b3', render)
  })

}


export default __exports__